import { AfterViewInit, Directive, HostListener, OnDestroy, Optional, Self } from '@angular/core';
import { QPointFormValidationService } from '../services/qpoint-form-validation.service';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[qpointValidationForm], form[formGroup]',
  providers: [QPointFormValidationService],
  standalone: true
})
export class QPointValidationFormDirective implements OnDestroy, AfterViewInit {
  constructor(private formValidationService: QPointFormValidationService, @Optional() @Self() private formGroup: FormGroupDirective) {
    this.formValidationService.setFormGroup(this);
  }

  ngAfterViewInit() {
    if (this.formGroup && this.formGroup.form) {
      const form = this.formGroup.form;
      const originalResetFormFunc = form.reset;

      form.reset = () => {
        originalResetFormFunc.apply(form, arguments);
        this.formValidationService.onFormReset(this);
      };

      const originalMarkAllAsTouchedFunc = form.markAllAsTouched;
      form.markAllAsTouched = () => {
        originalMarkAllAsTouchedFunc.apply(form, arguments);
        this.formValidationService.onFormSubmit(this)
      }
    }
  }

  @HostListener('submit')
  onSubmit() {
    this.formValidationService.onFormSubmit(this);
  }

  @HostListener('reset')
  onReset() {
    this.formValidationService.onFormReset(this);
  }

  ngOnDestroy(): void {
    this.formValidationService.removeFormGroup(this);
  }
}
